import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { getAgentsQuota } from 'api/Cerebro/orgScoped/agentsApi'
import { AgentsQuota } from 'api/Cerebro/orgScoped/agentsTypes'
import { useOrgContext } from 'context/OrgContext'
import { useUserContext } from 'context/UserContext'
import { useCerebroApiRequest } from 'hooks'

export function useAgentsQuotaQuery({
    enabled = true,
}: { enabled?: boolean } = {}): UseQueryResult<AgentsQuota | null, Error> {
    const makeCerebroApiRequest = useCerebroApiRequest({ throwOnError: true })
    const { orgId, orgGroupId } = useOrgContext()
    const { userId } = useUserContext()

    return useQuery({
        queryKey: ['agents', 'quota', orgId, orgGroupId ?? null, userId],
        enabled: enabled && Boolean(orgId),
        queryFn: async (): Promise<AgentsQuota | null> => {
            const response = await makeCerebroApiRequest({
                request: getAgentsQuota(),
                suppressErrorAlerts: true,
            })
            return response?.data ?? null
        },
    })
}
